import { useEffect } from "react";
import DigitalCardLayout from "../components/DigitalCardLayout"

const CurvyOrangeStatic = () => {
    useEffect(() => {
        import("./Curvyorange.css");
    }, [])
    return (
        <DigitalCardLayout>
            <div class="box-divider" id="basic">
    <div class="card-wrapper shadow">
        <div class="card-head">
            <div class="profile-image">
                <img src="/assets/images/johndoe.jpg" alt="profilepic" />
            </div>
            <div class="card-head-logo">
                <img src="/assets/images/comp.png" alt="logo" />
            </div>
        </div>
        <div class="pt-3 p-15px">
            <h1 class="h3 profil-name mb-0">John Doe</h1>
            <p class="m-0">CEO</p>
            <p class="mb-0">John Associates</p>
            <div class="social-border d-flex mt-3">
                <ul class="social_box">
                    <li>
                        <a href="#" target="_blank"><i class='bx bxl-facebook'></i></a>
                    </li>
                    <li>
                        <a href="#" target="_blank"><i class='bx bxl-twitter'></i></a>
                    </li>
                    <li>
                        <a href="#" target="_blank"><i class='bx bxl-instagram'></i></a>
                    </li>
                    <li>
                        <a href="#" target="_blank"><i class='bx bxl-linkedin'></i></a>
                    </li>
                    <li>
                        <a href="#" target="_blank"><i class='bx bxl-whatsapp'></i></a>
                    </li>
                </ul>
            </div>
            <ul class="contact_box mt-3">
                <li>
                    <div class="d-flex">
                        <div class="contact_icon">
                            <i class='bx bxs-phone'></i>
                        </div>
                        <div class="contact_content">
                            <a href="tel:#">+91 9830565580</a>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="d-flex">
                        <div class="contact_icon">
                            <i class='bx bxs-envelope'></i>
                        </div>
                        <div class="contact_content">
                            <a href="mailto:#">johndoe@example.com</a>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="d-flex">
                        <div class="contact_icon">
                            <i class='bx bx-globe'></i>
                        </div>
                        <div class="contact_content">
                            <a href="#" target="_blank">example.com</a>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="d-flex">
                        <div class="contact_icon">
                            <i class='bx bxs-map'></i>
                        </div>
                        <div class="contact_content">
                            <a href="#" target="_blank">
                                33, Townshend Road, Purnashish Building, Ground Floor,
                                Kolkata -700025 West Bengal, India
                            </a>
                        </div>
                    </div>
                </li>
            </ul>
            {/* <div class="share_box">
                <div class="share_form">
                    <input type="text" value="+91 " />
                    <button type="button"><i class='bx bxl-whatsapp'></i> Share On WhatsApp</button>
                </div>
                <div class="row share_btns">
                    <div class="col-6">
                        <button class="btn btn-dark" id="savetocontact">Save to Contacts <i class='bx bx-download'></i></button>
                    </div>
                    <div class="col-6">
                        <button class="btn btn-dark">Share <i class='bx bx-share-alt'></i></button>
                    </div>
                </div>
            </div> */}
        </div>
    </div>
</div>
<div class="box-divider" id="about">
    <div class="card-wrapper card-border shadow">
        <div class="p-15px paragraph-14px">
            <h2 class="h4">About</h2>
            <p>John Doe is a pseudonym used to represent an anonymous or hypothetical individual, often in legal contexts, where the true identity is either unknown or intentionally withheld. This generic name has become emblematic of anonymity in various fields, from legal proceedings to literature and film. John Doe serves as a placeholder, embodying the everyman or the common person, devoid of specific characteristics or identity markers.</p>
            <p>In legal contexts, John Doe is frequently employed when referring to unidentified parties in lawsuits or criminal cases. For instance, a plaintiff might file a lawsuit against "John Doe" if they are unaware of the defendant's true identity but wish to proceed with legal action. Similarly, law enforcement might issue a warrant for the arrest of a suspect known only as John Doe until their identity is determined.</p>
            <p>Outside of the legal realm, the name John Doe has permeated popular culture, appearing in various works of fiction, such as novels, films, and television shows. In these contexts, John Doe often represents an enigmatic figure, shrouded in mystery or operating under an assumed identity. This archetype has been explored in numerous genres, including crime thrillers, psychological dramas, and science fiction, adding to its enduring appeal and cultural significance.</p>
            <p>Beyond its use in formal and creative contexts, John Doe has also found its way into everyday language as a symbol of anonymity and universality. When individuals wish to convey a sense of anonymity or represent the average person, they might use the term "John Doe" or its female counterpart, "Jane Doe." This widespread usage underscores the enduring relevance of John Doe as a symbol of anonymity and the universal human experience.</p>
        </div>
    </div>
</div>
<div class="box-divider" id="shop">
    <div class="card-wrapper card-border shadow">
        <div class="p-15px">
            <h2 class="h4">Shop Online</h2>
            <div class="row">
                <div class="col-6">
                    <div class="product_box">
                        <div class="product-image">
                            <img src="~/assets-new/img/product/02.jpg" alt="product" />
                        </div>
                        <div class="product-content text-center">
                            <h3 class="h6">DSC</h3>
                            <span class="text-muted">₹ 885</span>
                        </div>
                        <button class="btn btn-primary w-100">Buy</button>
                    </div>
                </div>
                <div class="col-6">
                    <div class="product_box">
                        <div class="product-image">
                            <img src="~/assets-new/img/product/02.jpg" alt="product" />
                        </div>
                        <div class="product-content text-center">
                            <h3 class="h6">DSC</h3>
                            <span class="text-muted">₹ 885</span>
                        </div>
                        <button class="btn btn-primary w-100">Buy</button>
                    </div>
                </div>
                <div class="col-6">
                    <div class="product_box">
                        <div class="product-image">
                            <img src="~/assets-new/img/product/02.jpg" alt="product" />
                        </div>
                        <div class="product-content text-center">
                            <h3 class="h6">DSC</h3>
                            <span class="text-muted">₹ 885</span>
                        </div>
                        <button class="btn btn-primary w-100">Buy</button>
                    </div>
                </div>
                <div class="col-6">
                    <div class="product_box">
                        <div class="product-image">
                            <img src="~/assets-new/img/product/02.jpg" alt="product" />
                        </div>
                        <div class="product-content text-center">
                            <h3 class="h6">DSC</h3>
                            <span class="text-muted">₹ 885</span>
                        </div>
                        <button class="btn btn-primary w-100">Buy</button>
                    </div>
                </div>
                <div class="col-6">
                    <div class="product_box">
                        <div class="product-image">
                            <img src="~/assets-new/img/product/02.jpg" alt="product" />
                        </div>
                        <div class="product-content text-center">
                            <h3 class="h6">DSC</h3>
                            <span class="text-muted">₹ 885</span>
                        </div>
                        <button class="btn btn-primary w-100">Buy</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="box-divider" id="products">
    <div class="card-wrapper card-border shadow">
        <div class="p-15px">
            <h2 class="h4">Products & Services</h2>
            <div class="row">
                <div class="col-12">
                    <div class="product_box">
                        <div class="product-image">
                            <img src="~/assets-new/img/product/02.jpg" alt="product" />
                        </div>
                        <div class="product-content text-center">
                            <h3 class="h6">DSC</h3>
                        </div>
                        <button class="btn btn-primary w-100">Enquiry</button>
                    </div>
                </div>
                <div class="col-12">
                    <div class="product_box">
                        <div class="product-image">
                            <img src="~/assets-new/img/product/02.jpg" alt="product" />
                        </div>
                        <div class="product-content text-center">
                            <h3 class="h6">DSC</h3>
                        </div>
                        <button class="btn btn-primary w-100">Enquiry</button>
                    </div>
                </div>
                <div class="col-12">
                    <div class="product_box">
                        <div class="product-image">
                            <img src="~/assets-new/img/product/02.jpg" alt="product" />
                        </div>
                        <div class="product-content text-center">
                            <h3 class="h6">DSC</h3>
                        </div>
                        <button class="btn btn-primary w-100">Enquiry</button>
                    </div>
                </div>
                <div class="col-12">
                    <div class="product_box">
                        <div class="product-image">
                            <img src="~/assets-new/img/product/02.jpg" alt="product" />
                        </div>
                        <div class="product-content text-center">
                            <h3 class="h6">DSC</h3>
                        </div>
                        <button class="btn btn-primary w-100">Enquiry</button>
                    </div>
                </div>
                <div class="col-12">
                    <div class="product_box">
                        <div class="product-image">
                            <img src="~/assets-new/img/product/02.jpg" alt="product" />
                        </div>
                        <div class="product-content text-center">
                            <h3 class="h6">DSC</h3>
                        </div>
                        <button class="btn btn-primary w-100">Enquiry</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="box-divider" id="gallery">
    <div class="card-wrapper shadow card-border">
        <div class="p-15px">
            <h2 class="h4">Gallery</h2>
            <div class="row">
                <div class="col-12">
                    <div class="product_box">
                        <div class="product-image">
                            <img src="~/assets-new/img/product/02.jpg" alt="product" />
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="product_box">
                        <div class="product-image">
                            <img src="~/assets-new/img/product/02.jpg" alt="product" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="box-divider" id="payment">
    <div class="card-wrapper shadow card-border">
        <div class="p-15px">
            <h2 class="h4">Payment Info</h2>
            <div class="h6">Bank Account Details:-</div>
            <div class="table-responsive">
                <table class="table bankdetails">
                    <tbody>
                        <tr>
                            <td>Name</td>
                            <td>:</td>
                            <td>JOHN ASSOCIATES</td>
                        </tr>
                        <tr>
                            <td>Account No.</td>
                            <td>:</td>
                            <td>1812897529</td>
                        </tr>
                        <tr>
                            <td>IFSC Code</td>
                            <td>:</td>
                            <td>KKBK0001383</td>
                        </tr>
                        <tr>
                            <td>Bank Name</td>
                            <td>:</td>
                            <td>Kotak Mahindra Bank</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="qr-code">
                <img src="~/assets-new/img/product/qr.webp" alt="qr" />
            </div>
        </div>
    </div>
</div>
<div class="box-divider" id="contact">
    <div class="card-wrapper shadow card-border no-bottom-bg">
        <div class="p-15px">
            <h2 class="h4">Contact</h2>
            <div class="form-group mb-3">
                <div class="mb-2">
                    <input type="text" id="yourname_CNT" placeholder="Your Name" class="form-control" />
                </div>
                <div class="mb-2">
                    <input type="email" id="emailid_CNT" placeholder="Email ID" class="form-control" />
                </div>
                <div class="mb-2">
                    <input type="tel" id="phonenumber_CNT" placeholder="Your Contact" class="form-control" />
                </div>
                <div class="mb-2">
                    <textarea id="feedback_CNT" placeholder="Your Message" class="form-control"></textarea>
                </div>
                <button class="btn btn-primary w-100">Send!</button>
            </div>
        </div>
        <footer class="footer">
            <a href="#" class="fsize-14">emastersindia.net || Make Your Own Card Now || 2024</a>
        </footer>
    </div>
</div>
        </DigitalCardLayout>
    )
}

export default CurvyOrangeStatic;